import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=01f8d309&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f8d309",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01f8d309')) {
      api.createRecord('01f8d309', component.options)
    } else {
      api.reload('01f8d309', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=01f8d309&scoped=true&", function () {
      api.rerender('01f8d309', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2KaeWOmLV6jQJ/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports